import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const vonage = defineConnector({
  identifier: "vonage",
  name: "Vonage",
  tagLine: "Communications APIs for voice, SMS, and video",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://(rest|api)\\.nexmo\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.apiKey,
      password: app.secret.apiSecret,
    }),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to the [Vonage API Dashboard](https://dashboard.nexmo.com/). Your API key and API secret are displayed on the home page under **API settings**.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "configuration", field: "apiKey" },
        },
        {
          kind: "input",
          label: "API secret",
          required: true,
          target: { kind: "secrets", field: "apiSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://rest.nexmo.com/account/get-balance",
  },
});
